import React, { Component } from "react";
import { object, string } from "prop-types";
import _ from 'lodash'

// utils
import { createQuery, runQuery } from "../../../utils/KeenReport";
import { post } from "../../../utils/apiService";
import { formatPercentage } from "../../../utils/numeral";

// components
import Spinner from "../../Spinner";
import CompleteFunnelGraph from "../CompleteFunnelGraph";

class RegularFunnelWithUnderstanding extends Component {
  constructor(props) {
    super(props);

    let uniqueId;
    if (this.props.video) {
      uniqueId =
        "regularfunnelwithunderstanding" +
        this.props.video.id +
        this.props.actor;
    } else {
      uniqueId =
        "regularfunnelwithunderstanding" +
        this.props.campaign.id +
        this.props.actor;
    }

    this.state = {
      isLoading: true,
      hasError: false,
      uniqueId: uniqueId
    };

    this.runKeen = this.runKeen.bind(this);
    this.changeState = this.changeState.bind(this);
    this.createQueries = this.createQueries.bind(this);
    this.buildQueriesForPeople = this.buildQueriesForPeople.bind(this);
    this.buildQueriesForEvents = this.buildQueriesForEvents.bind(this);
    this.getSendingsSize = this.getSendingsSize.bind(this);
    this.buildDataForGraph = this.buildDataForGraph.bind(this);
  }
  componentDidMount() {
    this.runKeen(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.timeframe, this.props.timeframe)) {
      this.changeState("loading");
      this.runKeen(nextProps);
    }
    if (!_.isEqual(nextProps.filters, this.props.filters)) {
      this.changeState("loading");
      this.runKeen(nextProps);
    }
  }
  changeState(type) {
    let isLoading, hasError;
    switch (type) {
      case "loading":
        isLoading = true;
        hasError = false;
        break;
      case "error":
        isLoading = false;
        hasError = true;
        break;
      case "done":
        isLoading = false;
        hasError = false;
        break;
      default:
        isLoading = false;
        hasError = false;
        break;
    }

    this.setState({
      isLoading,
      hasError
    });
  }
  buildQueriesForPeople(props) {
    const { campaign, timeframe, video, filters } = props;
    let queries = [];
    let extraFilters = filters;
    // Cliques
    queries.push(
      createQuery(
        "count_unique",
        "url_expanded",
        timeframe,
        null,
        video,
        "viewer_id",
        null,
        extraFilters
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count_unique",
        "video_recomended",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        extraFilters
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count_unique",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        extraFilters
      )
    );
    // Understanding
    // queries.push(
    //   createQuery(
    //     "count",
    //     "user_interacted",
    //     timeframe,
    //     campaign,
    //     video,
    //     "client_viewer_id",
    //     null,
    //     [
    //       ...extraFilters,
    //       {
    //         operator: "eq",
    //         property_name: "source",
    //         property_value: "entendeu-diferenca"
    //       },
    //       { operator: "eq", property_name: "value", property_value: "sim" }
    //     ]
    //   )
    // );
    // Conversoes
    queries.push(
      createQuery(
        "count",
        "ux",
        timeframe,
        campaign,
        video,
        "client_viewer_id",
        null,
        [
          ...extraFilters,
          {
            operator: "eq",
            property_name: "source",
            property_value: "baixar-app"
          }
        ]
      )
    );
    return queries;
  }
  buildQueriesForEvents(props) {
    const { campaign, timeframe, video, filters } = props;
    let queries = [];
    let extraFilters = filters;
    // Cliques
    queries.push(
      createQuery(
        "count",
        "url_expanded",
        timeframe,
        null,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Visitas
    queries.push(
      createQuery(
        "count",
        "video_recomended",
        timeframe,
        campaign,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Plays
    queries.push(
      createQuery(
        "count",
        "video_unique_click",
        timeframe,
        campaign,
        video,
        null,
        null,
        extraFilters
      )
    );
    // Understanding
    // queries.push(
    //   createQuery(
    //     "count",
    //     "user_interacted",
    //     timeframe,
    //     campaign,
    //     video,
    //     null,
    //     null,
    //     [
    //       ...extraFilters,
    //       {
    //         operator: "eq",
    //         property_name: "source",
    //         property_value: "entendeu-diferenca"
    //       },
    //       { operator: "eq", property_name: "value", property_value: "sim" }
    //     ]
    //   )
    // );
    // Conversoes
    queries.push(
      createQuery("count", "ux", timeframe, campaign, video, null, null, [
        ...extraFilters,
        {
          operator: "eq",
          property_name: "source",
          property_value: "baixar-app"
        }
      ])
    );
    return queries;
  }
  createQueries(props) {
    const { actor } = props;
    let queries;
    if (actor === "pessoas") {
      queries = this.buildQueriesForPeople(props);
    } else {
      queries = this.buildQueriesForEvents(props);
    }
    return queries;
  }
  getSendingsSize(props) {
    return new Promise((resolve, reject) => {
      const { video, filters } = props;
      let filterRequest;
      if (filters.length > 0) {
        filterRequest = filters[0]["property_value"];
      } else {
        filterRequest = [];
      }
      let url = `/campaigns/${video.campaign_id}/videos/${
        video.id
      }/sending_tag_size`;
      let data = {
        sending_tags: filterRequest
      };
      post(url, data)
        .then(res => {
          let totalSendings = res.data.total_campaign_sendings_size;
          resolve(totalSendings);
        })
        .catch(err => {
          this.changeState("error");
          console.log("Error!!");
        });
    });
  }
  buildDataForGraph(results) {
    let actor = results.props.actor;
    let showTarget = actor === "pessoas";
    let dataForGraph = [
      {
        label: "URLs geradas",
        value: results.totalSendings,
        type: "line",
        rate: 1,
        color: "#d9d9d9"
      },
      {
        label: "Cliques",
        value: results.clicks,
        valueTarget: showTarget ? "362" : null,
        type: "line-plus",
        rate: formatPercentage(results.clicks / results.totalSendings),
        rateTarget: showTarget ? "18%" : null,
        color: "#bfe2f9"
      },
      {
        label: "Visitas",
        value: results.visits,
        valueTarget: showTarget ? "326" : null,
        type: "line-plus",
        rate: formatPercentage(results.visits / results.clicks),
        rateTarget: showTarget ? "90%" : null,
        color: "#7fc3f4"
      },
      {
        label: "Plays",
        value: results.plays,
        valueTarget: showTarget ? "260" : null,
        type: "line-plus",
        rate: formatPercentage(results.plays / results.visits),
        rateTarget: showTarget ? "80%" : null,
        color: "#3ca5f0"
      },
      // {
      //   label: "Entendimentos",
      //   value: results.understandings,
      //   valueTarget: showTarget ? "234" : null,
      //   type: "line-plus",
      //   rate: formatPercentage(results.understandings / results.plays),
      //   rateTarget: showTarget ? "90%" : null,
      //   color: "#144e8b"
      // },
      {
        label: "Conversões",
        value: results.conversions,
        valueTarget: showTarget ? "208" : null,
        type: "line-plus",
        rate: formatPercentage(results.conversions / results.plays),
        rateTarget: showTarget ? "80%" : null,
        color: "#0b355d"
      }
    ];

    this.setState({
      isLoading: false,
      hasError: false,
      dataForGraph
    });
  }
  runKeen(props) {
    let queries = this.createQueries(props);
    runQuery(queries)
      .then(res => {
        let clicks = res[0].result;
        let visits = res[1].result;
        let plays = res[2].result;
        // let understandings = res[3].result;
        let conversions = res[3].result;

        let results = {
          props,
          clicks,
          visits,
          plays,
          // understandings,
          conversions
        };

        this.getSendingsSize(props).then(totalSendings => {
          results["totalSendings"] = totalSendings;
          this.buildDataForGraph(results);
          this.changeState("done");
        });
      })
      .catch(err => {
        console.log("Erro rodando a query do Keen.", err);
        this.changeState("error");
      });
  }
  render() {
    let { isLoading, hasError } = this.state;
    return (
      <div>
        <div className={isLoading ? "hidden" : ""}>
          <CompleteFunnelGraph
            dataForGraph={this.state.dataForGraph}
            toggleVideoPlay={this.toggleVideoPlay}
            funnelType={this.props.funnelType}
          />
          {this.props.actor === "pessoas" && (
            <div
              style={{
                float: "right",
                marginRight: "24%",
                marginTop: "15px"
              }}
            >
              <small className="text-orange">&#9608; Campanha</small>
              <small className="text-purple ml20">&#9608; Target</small>
            </div>
          )}
        </div>
        <Spinner
          isLoading={isLoading}
          hasError={hasError}
          runKeen={() => {
            this.runKeen(this.props);
          }}
        />
      </div>
    );
  }
}

RegularFunnelWithUnderstanding.propTypes = {
  timeframe: object,
  campaign: object,
  actor: string,
  video: object
};

export default RegularFunnelWithUnderstanding;



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/RegularFunnelWithUnderstanding.js